import { Auth } from "aws-amplify";
import { logout } from "./helper";

export function authHeader() {
  // return authorization header with jwt token
  return new Promise((resolve, reject) => {
    Auth.currentAuthenticatedUser().then((res) => {
      res.getSession((err, session) => {
        if (err) {
          logout().then((res) => window.location.reload());
        } else if (!session.isValid()) {
          logout().then((res) => window.location.reload());
        } else {
          resolve({
            Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
            "x-access-token": session.getAccessToken().getJwtToken(),
          });
        }
      });
    });
  });
}

function parseJwt(token) {
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export function getDSaaSCandidateIdFromToken() {
  // return authorization header with jwt token
  return new Promise((resolve, reject) => {
    Auth.currentAuthenticatedUser().then((res) => {
      res.getSession((err, session) => {
        if (err) {
        } else if (!session.isValid()) {
        } else {
          const idToken = session.getIdToken().getJwtToken();
          const token = parseJwt(idToken);
          resolve(token["dsaascandidateid"]);
        }
      });
    });
  });
}
